/**
 * Loading Component
 * A wrapper component that provides a loading spinner with customizable
 * size, text, and variant options
 */

import React from "react";
import ModernLoader from "./ModernLoader";

/**
 * Loading Component
 * Renders a loading spinner with customizable properties
 * 
 * @param {Object} props - Component props
 * @param {string} props.size - Size of the loader ('small', 'medium', 'large')
 * @param {string} props.text - Text to display below the loader
 * @param {string} props.variant - Visual variant of the loader ('primary', 'secondary', etc.)
 * @returns {JSX.Element} Loading component with spinner
 */
const Loading = ({ size = "medium", text = "Loading...", variant = "primary" }) => {
  return (
    <div className="flex items-center justify-center h-full">
      <ModernLoader 
        size={size} 
        text={text} 
        variant={variant}
      />
    </div>
  );
};

export default Loading;
